import { render, staticRenderFns } from "./TransferTreeTwo.vue?vue&type=template&id=f85d90d2&scoped=true&"
import script from "./TransferTreeTwo.vue?vue&type=script&lang=js&"
export * from "./TransferTreeTwo.vue?vue&type=script&lang=js&"
import style0 from "./TransferTreeTwo.vue?vue&type=style&index=0&id=f85d90d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85d90d2",
  null
  
)

export default component.exports